import { createTheme } from '@mui/material';

// MUI TextField のデフォルトスタイルをstyleOverridesで修正しています。
// 一般的なラベル + 入力フォームの形にしたかったので、以下ページを参考にしました。(望月)
// https://qiita.com/honey32/items/b3585b75307b865267aa

const theme = createTheme({
  components: {
    MuiInputLabel: {
      styleOverrides: {
        asterisk: {
          display: 'none',
        },
        root: {
          '&.Mui-required::after': {
            content: "'必須'",
            color: 'red',
            position: 'relative',
            fontSize: '0.8rem',
            paddingLeft: '4px',
            lineHeight: '1',
            verticalAlign: 'middle',
          },
        },
        formControl: {
          position: 'static',
          transform: 'none',
          transition: 'none',

          pointerEvents: 'auto',
          cursor: 'pointer',

          display: 'inline',
          alignSelf: 'start',

          fontWeight: 'bold',
          // fontSize: "0.75rem",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          marginTop: 0,
        },
        input: {
          paddingTop: '10px',
          paddingBottom: '8px',
          height: 'auto',
        },
        notchedOutline: {
          top: 0,
          legend: {
            display: 'none',
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: 0,
        },
      },
    },
  },
  palette: {
    primary: {
      main: '#007DC5',
    },
    secondary: {
      main: '#808080',
    },
  },
});

export default theme;
